import { CoursesFilterEvent } from "@/data/eventbus";
import { Course } from "@/data/course";
import { Appointment } from "@/data/appointments";

function checkCourse(course: Course, filter: CoursesFilterEvent) {
    if( typeof filter.courseType !== 'undefined' && course.course_type?.id !== filter.courseType ) {
        return false;
    }
    if( typeof filter.location !== 'undefined' && course.location?.id !== filter.location ) {
        return false;
    }
    return true;
}

export function filterCourses(courses: Array<Course>, filter?: CoursesFilterEvent|null): Array<Course> {
    if( typeof filter === 'undefined' || !filter ) {
        return courses;
    }

    return courses.filter(course => checkCourse(course, filter));
}

export function filterAppointments(appointments: Array<Appointment>, filter?: CoursesFilterEvent|null): Array<Appointment> {
    if( typeof filter === 'undefined' || !filter ) {
        return appointments;
    }

    return appointments.filter(appointment => typeof appointment.course !== 'undefined' && appointment.course && checkCourse(appointment.course, filter));
}
